var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-fade-transition',{attrs:{"group":"","hide-on-leave":"","leave-absolute":""}},[_c(_vm.getCurrentComponent,{key:_vm.getCurrentComponent,tag:"component"}),_c('v-overlay',{key:"loader",attrs:{"value":_vm.getInitState.loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }